import { GlobalSiteSettingsContext } from "@/Context/GlobalSiteSettings"
import { useContextSelector } from "use-context-selector"

export const useConfirm = () => {
  return useContextSelector(GlobalSiteSettingsContext, v => v.actions.confirm);
};
